import React from 'react';

const BrandIcon = ({ children, className = '', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    className={className}
    {...props}
  >
    {children}
  </svg>
);

export const GitHubIcon = ({ className = '', ...props }) => (
  <BrandIcon className={className} {...props}>
    <path d="M12 .297a12 12 0 0 0-3.79 23.39c.6.113.82-.258.82-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.84 1.237 1.84 1.237 1.07 1.834 2.809 1.304 3.495.997.108-.776.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.93 0-1.31.469-2.38 1.236-3.22-.124-.303-.535-1.527.117-3.176 0 0 1.008-.322 3.301 1.23A11.52 11.52 0 0 1 12 6.844c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.649.242 2.873.118 3.176.77.84 1.235 1.91 1.235 3.22 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.103.823 2.222v3.293c0 .319.216.694.825.576A12.01 12.01 0 0 0 12 .297Z" />
  </BrandIcon>
);

export const LinkedInIcon = ({ className = '', ...props }) => (
  <BrandIcon className={className} {...props}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.028-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.266 2.37 4.266 5.455v6.286ZM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124ZM7.119 20.452H3.555V9h3.564v11.452ZM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003Z" />
  </BrandIcon>
);

export const YouTubeIcon = ({ className = '', ...props }) => (
  <BrandIcon className={className} {...props}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.13C19.505 3.55 12 3.55 12 3.55s-7.505 0-9.376.506a3.016 3.016 0 0 0-2.122 2.13A31.723 31.723 0 0 0 0 12a31.723 31.723 0 0 0 .502 5.814 3.016 3.016 0 0 0 2.122 2.13c1.871.506 9.376.506 9.376.506s7.505 0 9.376-.506a3.016 3.016 0 0 0 2.122-2.13A31.723 31.723 0 0 0 24 12a31.723 31.723 0 0 0-.502-5.814ZM9.546 15.568V8.432L15.818 12l-6.272 3.568Z" />
  </BrandIcon>
);
